import CarzRangeSearch from '../components/CarzRangeSearch.vue' 
Vue.component('carz-range-search', CarzRangeSearch)

const carzRangeSearchVueEnvironment = new Vue({
    delimiters: ['[%', '%]'],
    el: '.carzRangeSearchVueEnvironment',
});
